import Flex from '@Components/Bases/Flex';
import { Dialog, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

type ModalRedirectProps = {
  open: boolean;
};

const ModalRedirect = ({ open }: ModalRedirectProps) => {
  const [count, setCount] = useState(10);

  useEffect(() => {
    if (open) {
      const timer = setInterval(() => {
        setCount((prevCount) => {
          if (prevCount <= 1) {
            clearInterval(timer);
            localStorage.clear();
            window.location.href = process.env.REACT_APP_SET_LINK_URL || '/';
            return 0;
          }
          return prevCount - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [open]);

  return (
    <Dialog open={open}>
      <Flex flexDirection={'column'} gap={2} p={2} width={1}>
        <Typography fontWeight={'bold'}>
          มีผู้ใช้งานท่านอื่นเข้าสู่ระบบ CVUP
        </Typography>
        <Typography variant="body2" textAlign={'center'}>
          มีผู้ใช้งานท่านอื่นเข้าสู่ระบบ CVUP ด้วย User ที่คุณกำลังใช้อยู่
        </Typography>
        <Flex gap={1} alignItems={'center'} justifyContent={'center'}>
          <Typography>เราจะพาคุณกลับไปที่</Typography>
          <Link
            color={'info.main'}
            to={process.env.REACT_APP_SET_LINK_URL || '/'}
          >
            {process.env.REACT_APP_SET_LINK_URL}
          </Link>
          <Typography component={'span'}>{count} วินาที</Typography>
        </Flex>
      </Flex>
    </Dialog>
  );
};

export default ModalRedirect;
